import { createFileRoute } from '@tanstack/react-router';
import {
  DiscoverySessions,
  type SessionsSearch,
} from '@/components/discovery/sessions/sessions-screen';

/**
 * Discovery -> Sessions. Interviews and people on one screen (T-0186; the
 * transcript review is T-0187). The address names what is open on the
 * right: `review` (the review queue: `all`, an interview id, `doc:<id>` or
 * `area:<id>`), `intake` (Bring in files), `interview` (an id, or `new` for
 * the add form), `round` (the department round), `person`, `placement` (a
 * transcript to place, T-0261; `change` opens the add form pre-filled with
 * it), or `list=people` for the People list.
 */
const str = (v: unknown) => (typeof v === 'string' && v ? v : undefined);

export const Route = createFileRoute('/engagements/$engagementId/discovery/sessions')({
  validateSearch: (search: Record<string, unknown>): SessionsSearch => {
    const out: SessionsSearch = {};
    const interview = str(search.interview);
    const person = str(search.person);
    const round = str(search.round);
    const placement = str(search.placement);
    if (interview) out.interview = interview;
    if (person) out.person = person;
    if (round) out.round = round;
    if (placement) out.placement = placement;
    if (placement && (search.change === true || search.change === 'true' || search.change === 1)) {
      out.change = true;
    }
    if (search.list === 'people') out.list = 'people';
    const review = str(search.review);
    if (review) out.review = review;
    if (search.intake === true || search.intake === 'true' || search.intake === 1) {
      out.intake = true;
    }
    return out;
  },
  component: SessionsRoute,
});

function SessionsRoute() {
  const { engagementId } = Route.useParams();
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <DiscoverySessions
      engagementId={engagementId}
      search={search}
      onSearch={(next) => void navigate({ search: next, replace: true })}
    />
  );
}
